import { useIsMutating } from '@tanstack/react-query';

const courseIdOf = (variables: unknown) => {
  const v = variables as { id?: number; courseId?: number } | undefined;
  return v?.courseId ?? v?.id ?? null;
};

/** 同じコースへの保存（基本情報 { id }・ルート { courseId }・適用終了 { courseId }）が走っているか。保存中は詳細全体を操作不可にする（判断事項 16） */
export const useIsCourseSaving = (courseId: number) =>
  useIsMutating({ mutationKey: ['courseSave'], predicate: (m) => courseIdOf(m.state.variables) === courseId }) > 0;
